import { SESSION_TIMEOUT_CONFIG } from "@/constants/sessionTimeout";
let SessionManager = class SessionManager {
    static instance;
    lastExtensionTime = 0;
    warningTimer = null;
    logoutTimer = null;
    onWarningCallback = null;
    onTimeoutCallback = null;
    isAuthenticated = false;
    tokenExpiryTime = 0;
    constructor(){}
    static getInstance() {
        if (!SessionManager.instance) {
            SessionManager.instance = new SessionManager();
        }
        return SessionManager.instance;
    }
    // Set authentication state
    setAuthenticated(isAuth) {
        this.isAuthenticated = isAuth;
        if (!isAuth) {
            this.stopTracking();
        }
    }
    // Check if enough time has passed to allow session extension
    canExtendSession() {
        const now = Date.now();
        const timeSinceLastExtension = now - this.lastExtensionTime;
        return timeSinceLastExtension >= SESSION_TIMEOUT_CONFIG.SESSION_EXTENSION_THROTTLE;
    }
    // Reset timers (called on network requests or manual extension)
    resetTimers() {
        if (!this.isAuthenticated) return;
        this.clearTimers();
        // Set warning timer
        this.warningTimer = setTimeout(()=>{
            if (this.onWarningCallback) {
                this.onWarningCallback();
            }
        }, SESSION_TIMEOUT_CONFIG.WARNING_TIME);
        // Set logout timer
        this.logoutTimer = setTimeout(()=>{
            if (this.onTimeoutCallback) {
                this.onTimeoutCallback();
            }
        }, SESSION_TIMEOUT_CONFIG.LOGOUT_TIME);
    }
    // Mark session as extended (updates throttle timestamp)
    markSessionExtended() {
        const now = Date.now();
        this.lastExtensionTime = now;
        this.resetTimers();
    }
    // Clear all timers
    clearTimers() {
        if (this.warningTimer) {
            clearTimeout(this.warningTimer);
            this.warningTimer = null;
        }
        if (this.logoutTimer) {
            clearTimeout(this.logoutTimer);
            this.logoutTimer = null;
        }
    }
    // Set callbacks for warning and timeout
    setCallbacks(onWarning, onTimeout) {
        this.onWarningCallback = onWarning;
        this.onTimeoutCallback = onTimeout;
    }
    // Start session tracking
    startTracking() {
        // Prevent duplicate starts
        if (this.isAuthenticated) {
            // If already authenticated, just reset the timers
            this.resetTimers();
            return;
        }
        this.isAuthenticated = true;
        this.lastExtensionTime = Date.now();
        this.resetTimers();
    }
    // Stop session tracking
    stopTracking() {
        this.isAuthenticated = false;
        this.clearTimers();
        this.onWarningCallback = null;
        this.onTimeoutCallback = null;
        this.tokenExpiryTime = 0;
    }
    // Set token expiry time from server
    setTokenExpiry(expiryTime) {
        this.tokenExpiryTime = expiryTime;
    }
};
export const sessionManager = SessionManager.getInstance();
